import React from 'react'

type Props = {}

const WikiPage = (props: Props) => {
  return (
    <div className='w-full h-screen overflow-x-hidden bg-red-100'>





    </div>
  )
}

export default WikiPage